module.exports = __webpack_public_path__ + "img/mockup-mobile-donquicompte.6f56fa2f.png";